import store from "../../../store/store";
import { StoreState } from "../../../store/store.interface";
import { ProductCardData } from "../../product-card/product-card-display"
import { PredefinedFiltersObjects } from "../../search/interfaces/predefined-filters.interface"
import { SearchFacet, ViewTypeLabel } from "../../search/interfaces/search.interface";
import { selectSearchPageType } from "../../search/store/search.selector";
import { cleanFilterValueName } from "../../search/utils/predefined-filter.util";
import { getUserDataForUserAnalytics } from "../../user-profile/user-profile.selectors";

export function captureAnalyticsForPrintCatalogSearchListAndCardView(viewType: string, products: Array<ProductCardData>, 
predefinedFiltersObjectList: PredefinedFiltersObjects[], facets: SearchFacet[], predefinedFiltersList: string[]): any {
  return {
    name: 'view',
    detail: {
      eventName: `print-catalogue-items-${ viewType === ViewTypeLabel.LIST ? 'list' : 'card' }-view-loaded`,
      products: products?.map(product => {
        return {
          productTitle: product.title,
          programLabel: product.programLabel,
          programId: product.programId,
          mhid: product.mhid || '',
          isbn: product.mhid || product.isbn,
          isbn13: product.isbn13,
          price: product.netPrice,
          gradeLabel: product.gradeLevels,
          copywright: product.copyRightYear,
        }
      }),
      predefinedFilters: predefinedFiltersObjectList || [],
      facetsSelected: _getFacet(facets, predefinedFiltersList),
      searchPageType: selectSearchPageType(store.getState() as StoreState),
      user: getUserDataForUserAnalytics(store.getState() as StoreState),
      label: 'Print Catalogue Items View',
      comp: 'print-catalogue-items',
    },
  }
}

function _getFacet(facets: SearchFacet[], predefinedFiltersList: string[]): PredefinedFiltersObjects[] {
  const facetsResult: PredefinedFiltersObjects[] = [];

  facets?.map((facet) => {
    const filterName = facet.name
    facet.facetValues
      ?.filter((value) => value?.selected)
      ?.map((selectedFacet) => {
        if (!predefinedFiltersList.includes(cleanFilterValueName(selectedFacet.name))) {
          facetsResult.push({
            filterName: filterName,
            name: selectedFacet.name,
            label: selectedFacet.label
          });
        }
    })
  });
  return facetsResult;
}